import { render, staticRenderFns } from "./newAssurEuleuk.vue?vue&type=template&id=e23ef254&scoped=true"
import script from "./newAssurEuleuk.vue?vue&type=script&lang=js"
export * from "./newAssurEuleuk.vue?vue&type=script&lang=js"
import style0 from "./newAssurEuleuk.vue?vue&type=style&index=0&id=e23ef254&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e23ef254",
  null
  
)

export default component.exports